import { useNavigate } from 'react-router-dom';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthentication } from 'hooks/api/useAuthentication';
import { useRegistrationParams } from 'hooks/useRegistrationParams';

import LogoIcon from 'images/lumeo-logo-icon.svg?react';
import { Button } from 'components/Button/Button';
import { Heading } from 'components/Heading/Heading';
import { Text } from 'components/Text/Text';

export function RingExistingAccount() {
  const api = useAPI();
  const navigate = useNavigate();
  const { logout } = useAuthentication();
  const { clearParams } = useRegistrationParams();

  function handleLogout() {
    // Clear registration params
    clearParams();

    // Clean up local storage
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith('mqtt-token')) {
        try {
          const tokenID = JSON.parse(localStorage[key]).id;
          api.accessTokens.delete(tokenID);
        } catch {
          // do nothing
        } finally {
          localStorage.removeItem(key);
        }
      }
    });
    localStorage.removeItem('console.token');

    logout();
    navigate('/login', { replace: true });
  }

  return (
    <main className="flex min-h-screen items-center justify-center">
      <div className="w-full max-w-md space-y-8 px-4">
        <header className="flex flex-col items-center space-y-6">
          <LogoIcon className="h-12 w-auto" />

          <Heading level="1" className="text-center">
            Existing Lumeo accounts are not yet supported
          </Heading>

          <Text size="large" className="text-center text-gray-600">
            During Beta, Ring integration is only available for new Lumeo
            accounts. Please register a new Lumeo account by restarting the
            process from the Ring app.
          </Text>
        </header>

        <div className="flex justify-center pt-4">
          <Button variant="primary" size="large" onClick={handleLogout}>
            Logout
          </Button>
        </div>
      </div>
    </main>
  );
}
